import React from 'react';
import "../../styles/Blogs.css";


const CloudNativeServices = () => {
  return (
    <div className="b_b_contianer">
      <section className="b_b_section_one">
        <h1>
          Leveraging The Benefits of Cloud Native Services Without Facing Vendor
          Lock-In
        </h1>
      </section>

      <section className="b_b_section_two">
        <img
          className="b_b_section_two_img"
          src="../images/blog2_cloud_native.png"
          alt=""
        />
      </section>

      <section className="b_b_section_three">
        <p className="b_b_section_three_p1">
          Have you ever bought something from a third party before, and at some
          time you considered making a switch to a similar offering from a
          different seller? Were you confronted with various obstacles when you
          decided to make the switch? Well, you may have been locked-in. The
          term "vendor lock-in" describes a situation in which a consumer finds
          it challenging or impossible to switch to a different product or
          service provider after making an initial purchase. In the event that
          you are unable to switch vendors, you are said to be "locked in" to
          that provider.
        </p>
        <p className="b_b_section_three_p1">
          In relation to cloud computing, there are users who are stuck with the
          framework, design and services that their cloud service provider has
          decided upon. This is most likely because they thought it was the best
          choice for them at the time. However, when their firm expands and
          their data grows, they may need to switch vendors, which may not be
          possible.
        </p>

        <h4 className="b_b_section_four_h4">
          What Is The Problem of Cloud Vendor Lock-In?
        </h4>

        <p className="b_b_section_three_p1">
          Cloud vendor lock-in is a situation whereby the customer is locked
          into the service provider's strategy and underlying architecture. The
          majority of business IT solutions have been implemented in the public
          cloud. Infact over 90% of enterprises worldwide operate in the cloud.
          However, are the IT solutions effectively optimized for the cloud?
        </p>

        <p className="b_b_section_three_p1">
          According to public cloud service providers, a software application is
          considered as cloud optimized if the application is leveraging cloud
          native services. When an application is architected and developed to
          leverage cloud native services, the application cannot be cloud
          agnostic (ability for application to run on two or more cloud
          platforms). In other words, the application is locked into a specific
          cloud. Consequently, this results in vendor lock-in with the cloud
          service provider.
        </p>

        <h4 className="b_b_section_four_h4">
          How Akscel Application Platform Migitates The Problem of Cloud Vendor
          Lock-In
        </h4>
        <p className="b_b_section_three_p1">
          {" "}
          There is a common misconception that cloud native applications are
          developed for only one specific cloud. However, that’s not entirely
          true. Firstly, an application is a combination of the following layers
          which are:
        </p>

        <ul className="b_b_section_three_li">
          <li>Hardware</li>
          <li>Operating System</li>
          <li> Software to support the applications </li>
          <li> Services that integrate with the application </li>
          <li> Application </li>
        </ul>
        <p className="b_b_section_three_p1">
          The hardware, operating system and the software needed to support the
          applications are common in any public cloud. These layers can be
          provisioned using Infrastructure-as-Code. The infrastructure-as-code
          can be developed using cloud specific libraries or generic libraries
          that are cloud agnostic. The services that integrate with the software
          applications like messaging services and storage services are specific
          to the cloud service provider in which the application would be
          deployed.
        </p>
        <p className="b_b_section_three_p1">
          If the application code is abstracted from the cloud native service,
          the application would perform in any public cloud. Therefore, the only
          layer that is cloud specific are the cloud native integration services
          like messaging and storage services. All the public services offer
          similar services to integrate with application software. Hence, a
          cloud native application can be cloud agnostic if it can integrate
          with the cloud native services offered by public cloud service
          providers.
        </p>
        <p className="b_b_section_three_p2">
          Our low-code platform, Akscel Application Platform can develop cloud
          native solutions that can be deployed in any public cloud. Akscel
          Application Platform users need not worry about containers, security,
          and scalability as the solutions are cloud native. Applications
          developed with Akscel Application Platform are optimized to operate in
          the cloud, integrate with cloud native services, and do not lock in
          our customers to any public cloud.
        </p>
      </section>

      <section className="b_b_section_five">
        <h4 className="b_b_section_five_h4">The Wrap Up</h4>
        <p className="b_b_section_five_p1">
          Switching vendors is hard because migrating your data to another cloud
          native service might not be a walk in the park for you. You may also
          face downtime for a week or two while everything runs smoothly on the
          new system—or longer if something goes wrong during migration (which
          is likely). Consequently, customers may not want to utilize your
          product while they wait for you to come back online. Thereby,
          resulting in significant sales losses.
        </p>
        <p className="b_b_section_five_p1">
          Meanwhile, Akscel Application Platform tackles this issue on the
          platform itself by providing you with the flexibility to select the
          cloud service that best meets your needs. You have the option of
          deploying your application to a single cloud provider or multiple
          cloud providers. With Akscel Application Platform, you can design,
          build, deploy your application in a matter of minutes and easily
          switch between cloud service providers; thereby avoiding the problem
          of being locked in by a single cloud services vendor.
        </p>

        <p className="b_b_section_five_p1">
          Finally, Arshil offers end-to-end cloud migration services from
          on-premises to cloud to decrease costs, improve performance, and
          protect data security. We also support end-to-end cloud provider
          migrations as well as tenant-to-tenant migrations. Feel free to visit
          our product page to learn more and schedule a demo session with an
          expert.
        </p>
      </section>
    </div>
  );
}

export default CloudNativeServices